export const Constants = {
  LabelCampaign: 1,
  LabelAdgroup: 2,
  LabelKeyword: 3,
  LabelAd: 4,
  Label: 5,
  TimeHour: 6,
  TimeDay: 7,
  TimeDate: 8,
  TimeWeek: 9,
  TimeMonth: 10,
  TimeQuarter: 11,
  TimeYear: 12,
  Time: 13,
  SearchQuery: 20,
  UserLocation: 30,
  Geographic: 40,
  AgeGender: 50,
  LandingPage: 55,
  Publisher: 60,
  WebsiteURL: 70,
  CallDetails: 80,
  Shopping: 100,
  ShoppingCategory: 101,
  ShoppingProductType: 102,
  ShoppingBrand: 103,
  ShoppingItem: 104,
  ShoppingStore: 105,
  AccountLevel: 110,
  CampaignLevel: 120,
  AdgroupLevel: 130,
  LabelAccount: 140,
};
